import axios from 'axios';

import { useMutation } from '@tanstack/react-query';
import { API_URL } from '@/lib/apiUrl';

export const useResetPassword = () => {
  return useMutation({
    mutationFn: async (data: { key: string; password: string; passwordConfirm: string }) => {
      const response = await axios.post(API_URL + '/reset-password', {
        key: data.key,
        password: data.password,
        'password-confirm': data.passwordConfirm,
      });

      return response;
    },
  });
};

export default useResetPassword;
